class User {
  constructor(data) {
    this.data = data;
  }

  get id() {
    return this.data.id;
  }
  
  get name() {
    return `${this.data.first_name} ${this.data.last_name}`;
  }

  get firstName() {
    return this.data.first_name;
  }

  get lastName() {
    return this.data.last_name
  }

  get accountState() {
    return this.data.accountState;
  }

  get statusText() {
    return this.data.status_text;
  }    

  get email() {
    return this.data.email;
  }

  get thumbnail() {
    return ImageManager.hello(this);
  }
}
 
module.exports = User;


// WEBPACK FOOTER //
// ./src/models/user.js